import { createRuntimeServiceAccessKey } from '@dynamic-labs-sdk/client/core';

export type PhantomOriginTabService = {
  isOriginTab: boolean;
};

/**
 * Per-client service that tracks whether this JavaScript context is the
 * **originating tab** that initiated a Phantom redirect request.
 *
 * Calling `getPhantomOriginTab(client)` for the first time lazily creates the
 * service with `isOriginTab: false`. `setupPhantomListeners` sets it to `true`
 * immediately when a request is initiated, so `completePhantomRedirect` can
 * detect clone tabs by checking this flag.
 *
 * Because the service is stored in the client's `runtimeServices` Map (one
 * entry per client instance), it is naturally scoped to the current JavaScript
 * context — no browser globals (`sessionStorage`, `window`) are needed, making
 * this approach compatible with SSR and React Native.
 */
export const getPhantomOriginTab = createRuntimeServiceAccessKey(
  'phantomOriginTab',
  (): PhantomOriginTabService => ({ isOriginTab: false })
);
